<template>
  <div class="pi">
    <a-button type="primary" @click="backBefor()"
      ><a-icon type="left-circle"
    /></a-button>
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item v-bind="formItemLayout" extra="您希望别人怎么称呼?">
        <span slot="label">
          昵称&nbsp;
          <a-tooltip title="您希望别人怎么称呼?">
            <a-icon type="smile" theme="twoTone" />
          </a-tooltip>
        </span>
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入您的昵称!',
                  whitespace: true,
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <!-- <a-form-item v-bind="formItemLayout" label="手机号码">
        <a-input
          v-decorator="[
            'iphone',
            {
              rules: [{ required: true, message: '请输入手机号码!' }],
            },
          ]"
          style="width: 100%"
        >
          <a-select
            slot="addonBefore"
            v-decorator="['iphonePrefix', { initialValue: '86' }]"
            style="width: 70px"
          >
            <a-select-option value="86"> +86 </a-select-option>
            <a-select-option value="87"> +87 </a-select-option>
          </a-select>
        </a-input>
      </a-form-item>
      <a-form-item
        v-bind="formItemLayout"
        label="邮箱E-mail"
        extra="账号异常信息将会下发到这个邮箱"
      >
        <a-input
          v-decorator="[
            'mailbox',
            {
              rules: [
                {
                  type: 'email',
                  message: '输入的电子邮箱格式无效!',
                },
                {
                  required: true,
                  message: '请输入邮箱！',
                },
              ],
            },
          ]"
        />
      </a-form-item> -->
      <a-form-item v-bind="formItemLayout" label="简介" has-feedback>
        <a-input
          v-decorator="[
            'introduce',
            {
              rules: [
                {
                  required: true,
                  message: '请输入您的简介!',
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="所属地区">
        <a-cascader
          placeholder="请选择地区"
          :options="residences"
          :fieldNames="{ label: 'name', value: 'name', children: 'districts' }"
          v-decorator="[
            'region',
            {
              rules: [
                {
                  required: true,
                  message: '请选择区域！',
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="详细地址">
        <a-input
          v-decorator="[
            'address',
            {
              rules: [
                {
                  required: true,
                  message: '请输入详细地址',
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item v-bind="tailFormItemLayout">
        <a-button
          type="primary"
          icon="check"
          :loading="iconLoading"
          html-type="submit"
        >
          修改
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
export default {
  name: "pi",
  data() {
    return {
      netuser: this.$store.state.netuser,
      iconLoading: false,
      confirmDirty: false,
      residences: [],
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 16,
            offset: 8,
          },
        },
      },
    };
  },

  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "register" });
  },
  mounted() {
    this.init();
    console.log(this.$store.state.netuser.token);
  },
  methods: {
    init() {
      let key = "a9ae3cac102fe58e1cf3c3e55b339c1c";
      let xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
        "https://restapi.amap.com/v3/config/district?key=" +
          key +
          "&subdistrict=3"
      );
      xhr.send();
      xhr.onload = (e) => {
        // this.options = xhr.response  optionsk;
        // console.log(xhr.response)
        let optionsko = JSON.parse(xhr.response);
        this.residences = optionsko.districts[0].districts;
      };

      this.form.setFieldsValue({
        // sortId: this.netuser.id,
        name: this.netuser.name,
        // iphone: this.netuser.iphone,
        // mailbox: this.netuser.mailbox,
        introduce: this.netuser.introduce,
        address: this.netuser.address,
        region: [this.netuser.province, this.netuser.city, this.netuser.area],
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.iconLoading = true;
      let $this = this;
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // values.iphone = this.$Encrypt(values.iphone);
          // values.mailbox = this.$Encrypt(values.mailbox);
          values.address = this.$Encrypt(values.address);
          this.$post("/vr/netuser/updata/", values)
            .then(function (response) {
              if (response.code != 1) {
                $this.iconLoading = false;
                $this.$message.error(data.msg, 5);
                return;
              }
              $this.$store.commit("setStateUser", response.data);
              $this.$message.success("修改成功", 3);
              $this.iconLoading = false;
              $this.backBefor();
            })
            .catch(function (error) {
              console.log(error);
              $this.iconLoading = false;
            });
        } else {
          $this.iconLoading = false;
        }
      });
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    // onChange(value) {
    //   console.log(value);
    // },
  },
};
</script>

<style lang="less" scoped>
.pi {
  padding: 10px;
  width: 100%;
  background-color: rgb(255, 255, 255);
  //   .upstyle{
  //     text-align: center;
  //     margin-top: 10px;
  //   }
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/pi/uppi.vue